import type { Static } from 'runtypes';
import { Record, String, Optional } from 'runtypes';

export const BaseAiChatEventRuntype = Record({
  response: Optional(String),
  contextMetadata: String,
  message: String,
  reaction: Optional(String),
});

export type BaseAiChatEvent = Static<typeof BaseAiChatEventRuntype>;
